module.exports = __webpack_public_path__ + "static/media/PB_Y_06.612a859f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/yellow/PB_Y_06.png
// module id = 235
// module chunks = 0